<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：类型列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li v-for="type in skipTypes" :key="type.value"
              @click="handleTypeSelect(type.value)"
              :class="{ 'selected': selectedSkipType === type.value }">
              {{ type.label }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和菜单列表 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('indexMenu.search.title') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                v-model="searchForm.name"
                :placeholder="$t('indexMenu.search.name')"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.isShow"
                :placeholder="$t('indexMenu.search.isShow')"
                style="width:200px"
              >
                <el-option
                  v-for="item in isShowOptions"
                  :key="item.statusCd"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">
                {{ $t('common.search') }}
              </el-button>
              <el-button type="primary" @click="handleReset" icon="el-icon-refresh">
                {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 菜单列表 -->
        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('indexMenu.list.title') }} - {{ getCurrentTypeLabel() }}</span>
            <div>
              <el-button-group>
                <el-button type="primary" size="small" @click="openAddHouseKeepMenu">
                  <i class="el-icon-plus"></i>
                  {{ $t('indexMenu.button.addHouseKeep') }}
                </el-button>
                <el-button type="primary" size="small" @click="openAddServiceMenu">
                  <i class="el-icon-plus"></i>
                  {{ $t('indexMenu.button.addService') }}
                </el-button>
                <el-button type="primary" size="small" @click="openAddCategoryMenu">
                  <i class="el-icon-plus"></i>
                  {{ $t('indexMenu.button.addCategory') }}
                </el-button>
                <el-button type="primary" size="small" @click="openAddShopMenu">
                  <i class="el-icon-plus"></i>
                  {{ $t('indexMenu.button.addShop') }}
                </el-button>
                <el-button type="primary" size="small" @click="openAddMenu">
                  <i class="el-icon-plus"></i>
                  {{ $t('indexMenu.button.addMenu') }}
                </el-button>
              </el-button-group>
            </div>
          </div>

          <el-table
            :data="filteredTableData"
            style="width: 100%"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column prop="menuIcon" :label="$t('indexMenu.table.logo')" align="center" width="100">
              <template slot-scope="scope">
                <el-image style="width: 50px; height: 50px" :src="scope.row.menuIcon" fit="contain">
                  <div slot="error" class="image-slot">
                    <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px">
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('indexMenu.table.name')" align="center" />
            <el-table-column prop="seq" :label="$t('indexMenu.table.seq')" align="center" />
            <el-table-column prop="isShow" :label="$t('indexMenu.table.isShow')" align="center">
              <template slot-scope="scope">
                {{ scope.row.isShow === 'Y' ? $t('common.yes') : $t('common.no') }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('indexMenu.table.createTime')" align="center" />
            <el-table-column :label="$t('common.operation')" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="filteredTotal"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- 子组件 -->
    <add-index-menu ref="addIndexMenu" @success="handleSuccess" />
    <add-house-keep-menu ref="addHouseKeepMenu" @success="handleSuccess" />
    <add-service-menu ref="addServiceMenu" @success="handleSuccess" />
    <add-shop-menu ref="addShopMenu" @success="handleSuccess" />
    <add-category-menu ref="addCategoryMenu" @success="handleSuccess" />
    <edit-index-menu ref="editIndexMenu" @success="handleSuccess" />
    <delete-index-menu ref="deleteIndexMenu" @success="handleSuccess" />
  </div>
</template>

<script>
import { listShopMenu } from '@/api/phone/indexMenuApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import AddIndexMenu from '@/components/phone/AddIndexMenu'
import AddHouseKeepMenu from '@/components/phone/AddHouseKeepMenu'
import AddServiceMenu from '@/components/phone/AddServiceMenu'
import AddShopMenu from '@/components/phone/AddShopMenu'
import AddCategoryMenu from '@/components/phone/AddCategoryMenu'
import EditIndexMenu from '@/components/phone/EditIndexMenu'
import DeleteIndexMenu from '@/components/phone/DeleteIndexMenu'

export default {
  name: 'IndexMenuList',
  components: {
    AddIndexMenu,
    AddHouseKeepMenu,
    AddServiceMenu,
    AddShopMenu,
    AddCategoryMenu,
    EditIndexMenu,
    DeleteIndexMenu
  },
  data() {
    return {
      loading: false,
      searchForm: {
        name: '',
        isShow: ''
      },
      tableData: [],
      allTableData: [], // 存储所有数据
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      isShowOptions: [],
      shopId: '',
      selectedSkipType: '1', // 默认选中第一个类型
      skipTypes: [
        { value: '1', label: '商品分类', icon: 'el-icon-goods' },
        { value: '2', label: '商品菜单', icon: 'el-icon-shopping-cart-2' },
        { value: '3', label: '家政类型菜单', icon: 'el-icon-service' },
        { value: '4', label: '家政菜单', icon: 'el-icon-tools' },
        { value: '5', label: '站外菜单', icon: 'el-icon-link' }
      ]
    }
  },
  computed: {
    filteredTableData() {
      if (!this.selectedSkipType) return this.allTableData
      const filtered = this.allTableData.filter(item => item.skipType === this.selectedSkipType)
      // 分页处理
      const start = (this.pagination.current - 1) * this.pagination.size
      const end = start + this.pagination.size
      return filtered.slice(start, end)
    },
    filteredTotal() {
      if (!this.selectedSkipType) return this.allTableData.length
      return this.allTableData.filter(item => item.skipType === this.selectedSkipType).length
    }
  },
  created() {
    this.shopId = getShopId()
    this.getList()
    this.getDictData()
  },
  mounted() {
    // 默认选中第一个类型
    if (this.skipTypes.length > 0) {
      this.selectedSkipType = this.skipTypes[0].value
    }
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          name: this.searchForm.name,
          isShow: this.searchForm.isShow,
          shopId: this.shopId
        }
        const { data } = await listShopMenu(params)
        // 获取所有数据，前端根据 skipType 过滤
        this.allTableData = data || []
      } catch (error) {
        this.$message.error(this.$t('indexMenu.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async getDictData() {
      try {
        const data = await getDict('housekeeping_type', 'is_show')
        this.isShowOptions = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm.name = ''
      this.searchForm.isShow = ''
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    openAddMenu() {
      this.$refs.addIndexMenu.open()
    },
    openAddHouseKeepMenu() {
      this.$refs.addHouseKeepMenu.open()
    },
    openAddServiceMenu() {
      this.$refs.addServiceMenu.open()
    },
    openAddShopMenu() {
      this.$refs.addShopMenu.open()
    },
    openAddCategoryMenu() {
      this.$refs.addCategoryMenu.open()
    },
    handleEdit(row) {
      this.$refs.editIndexMenu.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteIndexMenu.open(row)
    },
    handleSuccess() {
      this.getList()
    },
    handleTypeSelect(skipType) {
      this.selectedSkipType = skipType
      this.pagination.current = 1
      // 不需要重新请求，因为数据已经在 allTableData 中
    },
    getCurrentTypeLabel() {
      const type = this.skipTypes.find(t => t.value === this.selectedSkipType)
      return type ? type.label : ''
    },
    openAddMenuByType() {
      switch (this.selectedSkipType) {
        case '1':
          this.openAddCategoryMenu()
          break
        case '2':
          this.openAddShopMenu()
          break
        case '3':
          this.openAddHouseKeepMenu()
          break
        case '4':
          this.openAddServiceMenu()
          break
        case '5':
          this.openAddMenu()
          break
        default:
          this.$message.warning('请先选择类型')
      }
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>